import { useState, useEffect } from "react";
import styles from "./index.module.scss";
import Container from "../../components/Container/Container";
import Layout from "../../components/Layout/Layout";
import Button from "../../components/UI/Button/Button";
import AdminTable from "./AdminTable";
import AdminAddForm from "./AddForm";
import { GetAllAdmins } from "../../ApiCalls";

export default function AdminList() {
  const [isAddFormOpen, setIsAddFormOpen] = useState(false);
  const [admins, setAdmins] = useState([]);

  useEffect(() => {
    const fetchAdmins = async () => {
      try {
        const res = await GetAllAdmins();
        if (res.data?.success) {
          setAdmins(res.data.admins);
        }
      } catch (error) {
        console.error("Failed to fetch admins:", error);
      }
    };
    fetchAdmins();
  }, []);

  const openAddForm = () => {
    setIsAddFormOpen(true);
  };

  const closeAddForm = () => {
    setIsAddFormOpen(false);
  };

  const handleSetAdmins = (newAdmins) => {
    setAdmins(newAdmins);
  };

  return (
    <>
      <Layout />
      <Container>
        <h2>Admin List</h2>
        <div className={styles.row}>
          <div className={styles.addButtonwrapper}>
            <Button onClick={openAddForm}>Add Admin</Button>
          </div>
        </div>
        <AdminTable items={admins} />
        <AdminAddForm
          isOpen={isAddFormOpen}
          onClose={closeAddForm}
          setAdmin={handleSetAdmins}
        />
      </Container>
    </>
  );
}
